import React from 'react';
import { makeStyles } from '@mui/styles';
import { Grid2 } from '@mui/material';

import { Page } from 'components';
import {
	Header,
	LatestProjects,
	NewProjects,
	RealTime,
	RoiPerCustomer,
	TeamTasks,
	TodaysMoney,
	SystemHealth,
	PerformanceOverTime,
} from './components';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	},
}));

const DashboardDefault = () => {
	const classes = useStyles();

	return (
		<Page className={classes.root} title="Default Dashboard">
			<Header />
			<Grid2 className={classes.container} container spacing={3}>
				<Grid2 item size={3}>
					<TodaysMoney />
				</Grid2>
				<Grid2 item size={3}>
					<NewProjects />
				</Grid2>
				<Grid2 item size={3}>
					<SystemHealth />
				</Grid2>
				<Grid2 item size={3}>
					<RoiPerCustomer />
				</Grid2>
				<Grid2 item size={3}>
					<RealTime />
				</Grid2>
				<Grid2 item size={9}>
					<PerformanceOverTime />
				</Grid2>
				<Grid2 item size={5}>
					<TeamTasks />
				</Grid2>
				<Grid2 item size={7}>
					<LatestProjects />
				</Grid2>
			</Grid2>
		</Page>
	);
};

export default DashboardDefault;
